export const redirectParam = (url) => `r=${url}`;

export default function (url) {
    if (!url) return;

    const redirect = encodeURIComponent(window.location.href);
    window.location.href = `${url}?${redirectParam(redirect)}`;
}
